const useServiceRequestNoteDefaults = ({
  requestType,
  meetingViaCalendly,
  translations = {},
  platformName,
}) => {
  const MEETING_OR_ELECTRONIC_SERVICE_REQUESTS = [
    'ServiceRequest::CoverLetterReview',
    'ServiceRequest::ResumeTailoring',
    'ServiceRequest::LinkedInReview',
    'ServiceRequest::ExecutiveBio',
    'ServiceRequest::BoardSearch',
    'ServiceRequest::RecruiterGuidanceSupport',
  ]
  const TRANSLATED_SERVICE_REQUESTS = [
    'ServiceRequest::OrientationCall',
    'ServiceRequest::ResumeTailoring',
    'ServiceRequest::JobSearchBurnout',
    'ServiceRequest::GeneralCheckIn',
    'ServiceRequest::TargetedResearch',
    'ServiceRequest::TargetCompanyResearch',
    'ServiceRequest::CoverLetterReview',
    'ServiceRequest::LinkedInReview',
    'ServiceRequest::JobSearchStrategy',
    'ServiceRequest::NetworkingStrategy',
    'ServiceRequest::InterviewPrep',
    'ServiceRequest::OnboardingSupport',
    'ServiceRequest::CareerPivotPlanning',
    'ServiceRequest::BoardSearch',
    'ServiceRequest::ExecutiveBio',
    'ServiceRequest::NegotiationStrategy',
    'ServiceRequest::RetirementSupport',
    'ServiceRequest::RecruiterGuidanceSupport',
    'ServiceRequest::MockInterview',
  ]

  const getDefaultMessaging = (key, type) => {
    if (translations[key] && TRANSLATED_SERVICE_REQUESTS.includes(key)) {
      if (typeof translations[key] === 'object' && type) {
        return translations[key][type] || ''
      }
      return translations[key].replace('%{platformName}', platformName)
    } else {
      if (typeof serviceRequestNoteDefaults[key] === 'object' && type) {
        return serviceRequestNoteDefaults[key][type] || ''
      }
      return serviceRequestNoteDefaults[key] || ''
    }
  }

  if (MEETING_OR_ELECTRONIC_SERVICE_REQUESTS.includes(requestType)) {
    return meetingViaCalendly
      ? getDefaultMessaging(requestType, 'meeting')
      : getDefaultMessaging(requestType, 'electronic')
  }
  return getDefaultMessaging(requestType)
}

export default useServiceRequestNoteDefaults

export const serviceRequestNoteDefaults = {
  'ServiceRequest::CoverLetterReview': {
    meeting:
      "It was great speaking with you [COACH TO EDIT (today or insert date you spoke)! As we discussed, I'm attaching your cover letter and a helpful checklist that you can use for future reference. Of course, if you need additional assistance, you can schedule another request or get immediate feedback by reaching out to one of our chat coaches. You can also use Ayla (our AI tool) to help you craft additional cover letters.",
    electronic:
      'Thank you for submitting your cover letter for review. Attached, you will find [COACH TO EDIT (checklist, new draft, feedback)] with feedback on your document. If you need additional assistance, you can book another cover letter service request or get immediate feedback by reaching out to one of our chat coaches. You can also use Ayla (our AI tool) to help you craft additional cover letters.',
  },
  'ServiceRequest::OnboardingSupport':
    'I enjoyed our meeting today to discuss onboarding into your new role. Be sure to regularly review your onboarding plan and feel free to return to Your Next Step and schedule another meeting to discuss your progress.',
  'ServiceRequest::RetirementSupport':
    'It was great meeting with you today. [COACH TO EDIT: Provide some information about the discussion and next steps for candidate.]\n\nYour {view_action_plan_button} will provide you with resources to help navigate the social and emotional changes associated with a transition to retirement. I encourage you to continue to follow your Action Plan steps and schedule additional meetings as they arise in your plan. To do so, simply log into Your Next Step and return to {view_professional_services_button}.\n\nThis is an exciting time planning for your next season and I’m looking forward to supporting you on the transition. You can also take advantage of Coach Chat between our sessions for immediate assistance from one of our many experienced career coaches.\n\nEnjoy the journey!',
  'ServiceRequest::ExecutiveBio': {
    meeting:
      'It was great meeting with you today to review your executive bio. As we discussed, I think it would be beneficial to [COACH TO EDIT (include what you spoke about)].',
    electronic:
      'Attached is a draft of your executive bio that I’ve tailored to reflect your personal brand and expertise. Please review it and feel free to make any adjustments that you feel better reflect your personality and skillset. Also, you can review the resources on the Your Next Step platform [COACH TO EDIT (list any helpful resources)] and use Ayla (our built-in AI tool) to assist you with further edits. Let me know if you have any questions!',
  },
  'ServiceRequest::BoardSearch': {
    meeting:
      'It was great meeting with you today! [COACH TO EDIT (write a brief recap of the conversation/candidate’s action items).]',
    electronic:
      'Thank you for your board search request. I’m attaching a document that will guide you through identifying your goals, finding your ideal fit, and tools to help you land a board member role. Take the time to read through this guide, research opportunities, and craft your documents.',
  },
  'ServiceRequest::RecruiterGuidanceSupport': {
    meeting:
      'It was nice speaking with you today! As a recap, we discussed [COACH TO EDIT (briefly summarize tactics you spoke about)]. I recommend using the recruiter search feature in the platform as well as searching for recruiters on LinkedIn (and any other suggestions you have). Additionally, you can find scripts for reaching out to recruiters {view_recruiter_resources}.',
    electronic:
      'I hope you’re doing well. Attached is the recruiter list based on the criteria you submitted. If you would like to view more recruiters, I recommend using the recruiter search feature in our platform as well as LinkedIn.  An easy way to locate  internal recruiters on LinkedIn is to search for the company you’re interested in, click “People,” and then search for “recruiter.” We also have resources on working with recruiters which you can find {view_recruiter_resources} along with scripts to assist in your outreach. I hope this is helpful!',
  },
  'ServiceRequest::JobSearchStrategy':
    'I enjoyed our conversation today! [COACH TO EDIT (Provide a summary of what you spoke about and any action steps for the candidate to take and any resources on the platform to read)].\n\nWhen you’re ready to meet for another session, simply log into Your Next Step and return to {view_professional_services_button}. You can also take advantage of Coach Chat between our sessions for immediate assistance from one of our many experienced career coaches.',
  'ServiceRequest::LinkedInReview': {
    meeting:
      'It was nice speaking with you and reviewing your LinkedIn profile today! [COACH TO EDIT (Briefly summarize highlights of the review)]. I’m closing out the review but if you need further assistance with your job search, feel free to submit another service request.',
    electronic:
      'Thank you for submitting your LinkedIn profile for review. I’m attaching a checklist that provides feedback for each section of your profile along with additional resources you might find helpful [COACH TO EDIT (attach documents and/or point to platform resources)]. If you need additional assistance with your profile, feel free to message me or reach out to one of our live chat coaches on the platform.',
  },
}
